import React from "react";
import Head from "../Components/Layout/Head";
import Footer from "../Components/Layout/Footer";
import { Search, Lightbulb, Settings, TrendingUp } from "lucide-react";
import { XCircle, CheckCircle } from "lucide-react";
import { useState, useEffect, useContext } from "react";
import ApiPath from "../Components/Common/Apiurl";
import { CountryContext } from "../CountryContext";
import PhoneInput from 'react-phone-number-input'
import 'react-phone-number-input/style.css'
import { isValidPhoneNumber } from 'react-phone-number-input'
import FooterNew from "../Components/Layout/FooterNew";
import { useNavigate } from "react-router-dom";

const LandingPage = () => {

  const country = useContext(CountryContext);
  const navigate = useNavigate();
  const websiteURL = window.location.origin;

  const [formVisible, setFormVisible] = useState(true);
  const [loading, setLoading] = useState(false);
  const [formError, setFormError] = useState("");

  const [selectedCountry, setSelectedCountry] = useState("India");

  const countryOptions = [
    "Australia",
    "Germany",
    "India",
    "New Zealand",
    "United States",
    "Other",
  ];

  const [phone, setPhone] = useState("");

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    country: "",
    message: "",
    firmType: "",
  });

  const [errors, setErrors] = useState({
    name: "",
    email: "",
    phone: "",
    country: "",
    firmType: '',
  });
  

  useEffect(() => {
    if (countryOptions.includes(country)) {
      setSelectedCountry(country);
    } else {
      setSelectedCountry("India");
    }
  }, [country]);

  const services = [
    { title: "AI Automation", img: "/assets/images/chatbot.png", desc: "Automate repetitive business tasks using intelligent AI systems to save time and reduce manual effort." },
    { title: "Workflow Automation", img: "/assets/images/workflow.png", desc: "Streamline end-to-end business processes by automating workflows across systems and teams." },
    { title: "AI Agents", img: "/assets/images/document-ai.png", desc: "Deploy smart AI agents that can handle tasks, make decisions, and interact with users autonomously." },
    { title: "Data Automation", img: "/assets/images/data-automation.png", desc: "Automatically collect, process, and analyze data to generate faster and more accurate insights." },
  ];

  const industries = [
    "Legal",
    "Real Estate",
    "Healthcare",
    "EdTech",
    "Enterprise",
  ];
  const steps = [
    {
      icon: <Search size={28} />,
      title: "Business Analysis",
      desc: "We analyze your workflows and identify areas where automation can create measurable business impact.",
    },
    {
      icon: <Lightbulb size={28} />,
      title: "Identify Automation Opportunities",
      desc: "We map repetitive processes and design AI-driven solutions to improve efficiency and reduce costs.",
    },
    {
      icon: <Settings size={28} />,
      title: "Build & Implement AI Solution",
      desc: "We develop and integrate custom AI systems tailored to your business operations and tools.",
    },
    {
      icon: <TrendingUp size={28} />,
      title: "Monitor & Optimize",
      desc: "We continuously improve performance and scale automation for long-term growth and ROI.",
    },
  ];
  const comparisonData = [
    {
      before: "Manual Work",
      after: "Automated Workflows",
    },
    {
      before: "Slow Response",
      after: "Instant Action",
    },
    {
      before: "Frequent Errors",
      after: "High Accuracy",
    },
    {
      before: "Data Overload",
      after: "Actionable Insights",
    },
    {
      before: "High Cost",
      after: "Cost Efficiency",
    },
    {
      before: "Limited Scale",
      after: "Scalable Systems",
    },
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value,
    });

    setErrors({
      ...errors,
      [name]: "",
    });

    if (name === "country") {
      setSelectedCountry(value);
    }

    // Reset phone when country dropdown changes
    if (name === "country") {
      if (value !== selectedCountry) {
        setSelectedCountry(value);
        setPhone(""); // clear phone input
        setErrors((prev) => ({
          ...prev,
          phone: "",
          country: "",
        }));
      }
    }

  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let newErrors = {
      name: "",
      email: "",
      phone: "",
      country: "",
      firmType: "",
    };

    let isValid = true;

    if (!formData.name.trim()) {
      newErrors.name = "Name is required";
      isValid = false;
    }

    const emailRegex = /^\S+@\S+\.\S+$/;

    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
      isValid = false;
    } else if (!emailRegex.test(formData.email.trim())) {
      newErrors.email = "Invalid email format";
      isValid = false;
    }

    if (!phone) {
      newErrors.phone = "Phone number is required";
      isValid = false;
    } else if (!isValidPhoneNumber(phone)) {
      newErrors.phone = "Please enter a valid phone number";
      isValid = false;
    }

    if (!formData.firmType) {
      newErrors.firmType = "Please select firm type";
      isValid = false;
    }

    if (!selectedCountry) {
      newErrors.country = "Please select country";
      isValid = false;
    }

    setErrors(newErrors);

    if (!isValid) return;

    const payload = {
      name: formData.name,
      email: formData.email.trim(),
      phone: phone,
      lookingFor: formData.firmType,
      queryPageIndex: "AI_AUTOMATION_PAGE",
      message:
        (formData.message || "") +
        ` IP: ${country} dropdown: ${selectedCountry} | URL: ${websiteURL}`,
    };

    try {
      setLoading(true);

      // const response = await fetch(ApiPath + "/api/enquiryController/tqAiEnquiry", {
      //   method: "POST",
      //   headers: {
      //     "Content-Type": "application/json",
      //   },
      //   body: JSON.stringify(payload),
      // });

        const response = await fetch(ApiPath + "/tqenquiry", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        setFormData({
          name: "",
          email: "",
          firmType: "",
          message: "",
        });

        setPhone("");
        setFormVisible(false);

        setTimeout(() => {
          setFormVisible(true);
          setLoading(false);
        }, 5000);
      } else {
        setFormError("Something went wrong. Please try again.");
        setLoading(false);
      }
    } catch (error) {
      console.error(error);
      setFormError("Something went wrong. Please try again.");
      setLoading(false);
    }
  };

  const getCountryCode = (country) => {
    const map = {
      India: "IN",
      "United States": "US",
      Australia: "AU",
      Germany: "DE",
      Japan: "JP",
      Singapore: "SG",
    };
    return map[country] || "US";
  };

 const navigateToWebinar = () => {
  if (window.location.pathname !== "/registerWebinar") {
    navigate("/registerWebinar");
  }
};


  return (
    <>
      <Head />
      <div className="overflow-hidden">

        <div className="bg-white text-gray-800">

          {/* HERO */}
          <section className="bg-gradient-to-br from-blue-50 via-white to-blue-100 py-12 sm:py-16 lg:py-12">
            <div className="w-full max-w-7xl mx-auto px-0 md:px-4 sm:px-6 md:px-8 lg:px-12 xl:px-20 flex flex-col lg:flex-row items-center gap-10">

              {/* LEFT CONTENT */}
              <div className="w-full lg:w-2/3 px-2 text-center lg:text-left">
                <span className="bg-blue-100 text-blue-600 px-3 py-1 rounded-full text-sm font-medium">
                  AI Automation Solutions
                </span>

                <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mt-4 leading-tight">
                  Eliminate Manual Work with AI-Powered Automation
                </h1>

                <p className="mt-4 text-base sm:text-lg text-gray-600 max-w-xl mx-auto lg:mx-0">
                  Build intelligent workflows, automate processes, and scale your business with AI solutions designed for real impact.
                </p>
                <div className="mt-6 flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">

                  <button
                    onClick={navigateToWebinar}
                    disabled={loading}
                    className={`relative group inline-flex items-center justify-center 
      px-6 py-3 rounded-xl font-semibold text-white 
      transition-all duration-300 shadow-md overflow-hidden
      ${loading
                        ? "bg-gray-400 cursor-not-allowed"
                        : "bg-blue-600 hover:bg-blue-700 hover:shadow-lg"
                      }`}
                  >

                    {/* Glow effect */}
                    <span className="absolute inset-0 bg-gradient-to-r from-blue-500 to-indigo-600 opacity-0 group-hover:opacity-20 transition duration-300"></span>

                    {/* Text */}
                    <span className="relative z-10 flex items-center gap-2">
                      {loading ? "Loading..." : "Register for Free Webinar"}

                      {!loading && (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-1"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                        </svg>
                      )}
                    </span>

                  </button>

                </div>
              </div>

              {/* RIGHT SIDE FORM */}
              <div className="w-full lg:w-1/3 flex justify-center lg:justify-end  mt-10 lg:mt-0">

                <div className="w-full max-w-lg bg-white shadow-2xl md:rounded-2xl p-5 sm:p-6 md:p-8 border border-gray-200">

                  {/* Success Message */}
                  {!formVisible && (
                    <div className="bg-blue-50 border border-blue-200 text-blue-700 px-5 py-5 rounded-xl mb-4 shadow-sm">
                      <div className="flex flex-col items-center text-center">
                        <CheckCircle
                          size={48}
                          className="text-blue-600 mb-3"
                          strokeWidth={2.2}
                        />

                        <h2 className="text-xl font-semibold mb-2">
                          Thank You!
                        </h2>

                        <p className="text-sm sm:text-base text-blue-700">
                          Thank you for contacting us. We'll get back to you soon.
                        </p>
                      </div>
                    </div>
                  )}

                  {/* Error Message */}
                  {formError && (
                    <div className="bg-red-50 border border-red-200 text-red-700 px-5 py-5 rounded-xl mb-4 shadow-sm">
                      <div className="flex flex-col items-center text-center">
                        <XCircle
                          size={44}
                          className="text-red-500 mb-3"
                          strokeWidth={2.2}
                        />

                        <h2 className="text-lg font-semibold mb-2">
                          Submission Failed
                        </h2>

                        <p className="text-sm sm:text-base">
                          {formError}
                        </p>
                      </div>
                    </div>
                  )}

                  {/* Form */}
                  {formVisible && (
                    <>
                      <h3 className="text-xl font-semibold text-center mb-6">
                        Book Appointment
                      </h3>

                      <form onSubmit={handleSubmit} className="space-y-4">

                        {/* Name */}
                        <div>
                          <input
                            type="text"
                            name="name"
                            placeholder="Full Name"
                            value={formData.name}
                            onChange={handleChange}
                            className={`w-full px-4 py-2 rounded-lg border 
              ${errors.name ? "border-red-500" : "border-gray-300"} 
              focus:ring-2 focus:ring-blue-500 outline-none`}
                          />
                          {errors.name && (
                            <p className="text-red-500 text-sm mt-1">{errors.name}</p>
                          )}
                        </div>

                        {/* Phone */}
                        <div className="w-full">
                          <div
                            className={`rounded-lg border px-3 py-2 ${errors.phone ? "border-red-500" : "border-gray-300"
                              }`}
                          >
                            <PhoneInput
                              key={selectedCountry}
                              countries={["IN", "US", "AU", "DE", "JP", "SG"]}
                              defaultCountry={getCountryCode(selectedCountry)}
                              international
                              value={phone}
                              onChange={(value) => {
                                setPhone(value || "");
                                setErrors({
                                  ...errors,
                                  phone: "",
                                });
                              }}
                              placeholder="Enter phone number"
                            />
                            {errors.phone && (
                              <p className="text-red-500 text-sm mt-1">
                                {errors.phone}
                              </p>
                            )}
                          </div>
                        </div>

                        {/* Email */}
                        <div>
                          <input
                            type="email"
                            name="email"
                            placeholder="Email ID"
                            value={formData.email}
                            onChange={handleChange}
                            className={`w-full px-4 py-2 rounded-lg border 
              ${errors.email ? "border-red-500" : "border-gray-300"} 
              focus:ring-2 focus:ring-blue-500 outline-none`}
                          />
                          {errors.email && (
                            <p className="text-red-500 text-sm mt-1">{errors.email}</p>
                          )}
                        </div>

                        <div className="mb-4">
                          <select
                            id="country"
                            name="country"
                            className={`w-full px-4 py-2 rounded-lg border 
                              ${errors.country ? "border-red-500" : "border-gray-300"} 
                              focus:ring-2 focus:ring-blue-500 outline-none`}
                            onChange={handleChange}
                            value={selectedCountry}
                            required
                          >

                            {countryOptions.map((country) => (
                              <option key={country} value={country}>
                                {country}
                              </option>
                            ))}
                          </select>
                        </div>

                        {/* Firm Type */}
                        <div>
                          <select
                            name="firmType"
                            value={formData.firmType}
                            onChange={handleChange}
                            className={`w-full px-4 py-2 rounded-lg border 
    ${errors.firmType ? "border-red-500" : "border-gray-300"} 
    focus:ring-2 focus:ring-blue-500 outline-none text-gray-700`}
                          >
                            <option value="">Select Firm Type</option>
                            <option value="Law and Legal">Law and Legal</option>
                            <option value="Manufacturing">Manufacturing</option>
                            <option value="Healthcare">Healthcare</option>
                            <option value="CA Firm">CA Firm</option>
                            <option value="Real Estate">Real Estate</option>
                            <option value="EdTech">EdTech</option>
                            <option value="Enterprise">Enterprise</option>
                            <option value="Other Firm">Other Firm</option>
                          </select>

                          {errors.firmType && (
                            <p className="text-red-500 text-sm mt-1">
                              {errors.firmType}
                            </p>
                          )}
                        </div>
                        {/* Submit */}
                        <button
                          type="submit"
                          disabled={loading}
                          className="w-full bg-blue-600 text-white py-3 rounded-lg hover:bg-blue-700 transition"
                        >
                          {loading ? "Submitting..." : "Submit"}
                        </button>

                      </form>
                    </>
                  )}

                </div>

              </div>

            </div>
          </section>

          {/* TRUST */}
          <section className="py-10 sm:py-12 bg-gray-50 text-center">
            <div className="max-w-6xl mx-auto px-4 sm:px-6 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 text-base sm:text-lg font-semibold">

              <div>40% Reduction in Manual Work</div>
              <div>3x Faster Automation</div>
              <div>AI Solutions Across Industries</div>
            </div>
          </section>

          {/* SERVICES */}
          <section className="py-14 sm:py-20 lg:py-24">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8 lg:px-10">
              <h2 className="text-3xl font-bold text-center">
                AI Solutions We Provide
              </h2>

              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8 mt-10 md:mt-14">
                {services.map((item, i) => (
                  <div
                    key={i}
                    className="p-6 rounded-2xl bg-white shadow-sm border hover:shadow-lg hover:-translate-y-2 transition duration-300 flex flex-col items-center text-center"
                  >
                    <img src={item.img} alt="" className="h-14 mb-4" />
                    <h3 className="font-semibold text-lg">{item.title}</h3>
                    <p className="text-sm text-gray-500 mt-2">
                      {item.desc}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* BEFORE VS AFTER AI */}
          <section className="py-14 sm:py-20 lg:py-24 bg-gray-50">
            <div className="max-w-6xl mx-auto px-4 sm:px-6 md:px-8 lg:px-10 text-center">

              <h2 className="text-3xl font-bold">
                Before vs After AI Automation
              </h2>

              <p className="text-gray-600 mt-4 max-w-2xl mx-auto">
                See how AI transforms your business operations and drives efficiency.
              </p>

              <div className="mt-10 md:mt-14 space-y-4 md:space-y-6">

                {comparisonData.map((item, index) => (
                  <div
                    key={index}
                    className="grid grid-cols-1 md:grid-cols-3 items-center gap-4 md:gap-6 bg-white p-4 sm:p-6 rounded-xl shadow-sm border"
                  >

                    {/* BEFORE */}
                    <div className="flex items-center justify-center gap-2 text-red-500 font-medium">
                      <XCircle size={20} />
                      {item.before}
                    </div>


                    {/* ARROW */}
                    <div className="text-gray-400 font-bold text-xl">
                      →
                    </div>

                    {/* AFTER */}
                    <div className="flex items-center justify-center gap-2 text-green-600 font-medium">
                      <CheckCircle size={20} />
                      {item.after}
                    </div>

                  </div>
                ))}

              </div>

            </div>
          </section>


          {/* WORKFLOW IMAGE */}
          <section className="py-14 sm:py-20 lg:py-24">
            <div className="max-w-6xl mx-auto px-4 sm:px-6 text-center">

              <h2 className="text-3xl font-bold">
                How We Help To Automates Your Business using AI
              </h2>

              <img
                src="/assets/images/aipoweredsolun.png"
                alt=""
                className="mt-8 md:mt-12 rounded-2xl shadow-xl mx-auto w-full max-w-5xl"
              />
            </div>
          </section>

          {/* USE CASE */}
          <section className="py-14 sm:py-20 lg:py-24">
            <div className="max-w-6xl mx-auto px-4 sm:px-6 grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center">

              <img
                src="/assets/images/document-ai.png"
                alt=""
                className="rounded-2xl shadow-xl w-full"
              />

              <div className="space-y-4">
                <div className="bg-red-50 p-4 rounded-lg">
                  <strong>Problem:</strong> Manual document processing
                </div>

                <div className="bg-blue-50 p-4 rounded-lg">
                  <strong>Solution:</strong> AI automation system
                </div>

                <div className="bg-green-50 p-4 rounded-lg">
                  <strong>Result:</strong> 60% faster processing
                </div>
              </div>

            </div>
          </section>

          {/* INDUSTRIES */}
          <section className="py-14 sm:py-20 lg:py-24 bg-gray-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 text-center">

              <h2 className="text-3xl font-bold">
                Industries We Serve
              </h2>

              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4 md:gap-6 mt-10 md:mt-12">
                {industries.map((item, i) => (
                  <div
                    key={i}
                    className="p-5 border rounded-xl bg-white hover:shadow-md"
                  >
                    {item}
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* CTA */}
          <section className="py-14 sm:py-20 lg:py-24 bg-gradient-to-r from-blue-600 to-blue-800 text-white">
            <div className="max-w-4xl mx-auto text-center px-4 sm:px-6">

              <h2 className="text-3xl font-bold">
                Ready to Automate Your Business?
              </h2>

              <p className="mt-4 text-blue-100">
                Talk to our AI experts and transform your operations.
              </p>

            </div>
          </section>

        </div>

        <FooterNew />

      </div>
    </>
  );
};

export default LandingPage;